// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomTableItem_tableheaderLogo__FAGfM {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
}

.CustomTableItem_itemElemetTitle__Ii7Fu {
    display: flex;
    align-items: center;
    justify-content: center;
}

.CustomTableItem_childrenItemBox__mgsuZ {
    display: flex;
    align-items: center;
}

.CustomTableItem_childrenItemTitleBox__Qby\\+v {
    font-family: "Roboto" sans-serif;
    font-size: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #9d9fa1;
    width: 100%;
    text-transform: uppercase;
    font-weight: bold;
    color: black;
    padding: 2px 7px;
}


.CustomTableItem_childrenItemBox__mgsuZ div {
    display: flex;
    align-items: center;
    border: 1px solid #9d9fa1;
    width: 240px;
    height: 32px;
    padding: 0 7px;
}

.CustomTableItem_childrenItemBox__mgsuZ div P {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 220px;
    height: 2em;
    white-space: pre;
    margin: 0;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.02857em;
    opacity: 1;
    text-transform: none;
    vertical-align: unset;
    -webkit-text-decoration: none;
    text-decoration: none;
    color: inherit;
    font-weight: 400;
    display: inline-block;
    width: max-content;
}

.CustomTableItem_ItemKeyFailed__HkV9- {
    color: red !important;
    font-weight: bold !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomTableItem/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,uDAAuD;IACvD,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,6BAA6B;IAC7B,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IAGrB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC","sourcesContent":[".tableheaderLogo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 0;\n}\n\n.itemElemetTitle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.childrenItemBox {\n    display: flex;\n    align-items: center;\n}\n\n.childrenItemTitleBox {\n    font-family: \"Roboto\" sans-serif;\n    font-size: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #9d9fa1;\n    width: 100%;\n    text-transform: uppercase;\n    font-weight: bold;\n    color: black;\n    padding: 2px 7px;\n}\n\n\n.childrenItemBox div {\n    display: flex;\n    align-items: center;\n    border: 1px solid #9d9fa1;\n    width: 240px;\n    height: 32px;\n    padding: 0 7px;\n}\n\n.childrenItemBox div P {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 220px;\n    height: 2em;\n    white-space: pre;\n    margin: 0;\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 0.875rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.02857em;\n    opacity: 1;\n    text-transform: none;\n    vertical-align: unset;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    color: inherit;\n    font-weight: 400;\n    display: inline-block;\n    width: -webkit-max-content;\n    width: -moz-max-content;\n    width: max-content;\n}\n\n.ItemKeyFailed {\n    color: red !important;\n    font-weight: bold !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableheaderLogo": `CustomTableItem_tableheaderLogo__FAGfM`,
	"itemElemetTitle": `CustomTableItem_itemElemetTitle__Ii7Fu`,
	"childrenItemBox": `CustomTableItem_childrenItemBox__mgsuZ`,
	"childrenItemTitleBox": `CustomTableItem_childrenItemTitleBox__Qby+v`,
	"ItemKeyFailed": `CustomTableItem_ItemKeyFailed__HkV9-`
};
export default ___CSS_LOADER_EXPORT___;
